const num = (v) => Number(v) || 0;

export function toSalesTrendSeries(months) {
  const rows = Array.isArray(months) ? months : [];
  return {
    labels: rows.map((m) => m.month),
    revenue: rows.map((m) => num(m.revenue)),
    orders: rows.map((m) => num(m.orders)),
  };
}

export function toOrderStatusSeries(statuses) {
  const rows = Array.isArray(statuses) ? statuses : [];
  return {
    labels: rows.map((s) => s.status),
    counts: rows.map((s) => num(s.count)),
    amounts: rows.map((s) => num(s.amount)),
  };
}

export function toPipelineSeries(stages) {
  const rows = Array.isArray(stages) ? stages : [];
  return {
    labels: rows.map((s) => s.stage),
    amounts: rows.map((s) => num(s.amount)),
    counts: rows.map((s) => num(s.count)),
  };
}

export function toTopCustomersSeries(customers) {
  const rows = Array.isArray(customers) ? customers : [];
  return {
    labels: rows.map((c) => c.customerName),
    amounts: rows.map((c) => num(c.amount)),
  };
}
